import { STAGE_LABEL, STAGE_EMOJI, STAGE_COLOR, STAGE_BG } from "@/types";
import type { LifecycleStage } from "@/types";
import clsx from "clsx";

interface Props {
  stage: LifecycleStage;
  /** β-9 D 항목: declining 세분화 — 'bubble' (🫧 거품) / 'fading' (📉 일반). 다른 단계는 무시. */
  substage?: "bubble" | "fading" | null;
  size?: "sm" | "md";
  className?: string;
}

// declining 세분화 라벨·이모지 매핑
const SUBSTAGE_LABEL: Record<string, { emoji: string; label: string }> = {
  bubble: { emoji: "🫧", label: "거품 단계" },
  fading: { emoji: "📉", label: "일반 하락" },
};

export function LifecycleBadge({ stage, substage, size = "md", className }: Props) {
  const color = STAGE_COLOR[stage];
  const bg = STAGE_BG[stage];

  // declining + substage 가 있으면 세분화 라벨 사용. 그 외는 기본 단계 라벨.
  const sub = stage === "declining" && substage ? SUBSTAGE_LABEL[substage] : null;
  const emoji = sub?.emoji ?? STAGE_EMOJI[stage];
  const label = sub?.label ?? STAGE_LABEL[stage];

  return (
    <span
      className={clsx(
        "inline-flex items-center gap-0.5 font-semibold rounded-full",
        // 2026-06-02 — sm 더 컴팩트 (홈 메뉴 추천 키워드 text-sm 옆에 비율 맞춤)
        size === "sm" ? "px-1.5 py-px text-2xs" : "px-2.5 py-1 text-xs",
        className
      )}
      style={{ color, backgroundColor: bg }}
    >
      {emoji} {label}
    </span>
  );
}
